import dayjs from 'dayjs'
import localize from 'dayjs/plugin/localizedFormat'

import { createUseStyles, useTheme } from 'react-jss'
import PropTypes from 'prop-types'

dayjs.extend(localize)

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  label: {
    fontSize: 12,
    fontWeight: 500,
    color: ({ theme }) => theme.textGrayColor,
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: ({ theme }) => theme.textColor,
  },
  valueSecondary: {
    fontSize: 12,
    color: ({ theme }) => theme.textGrayColor,
    fontWeight: 400,
  },
})

export default function EstimatedLongevity({ estimatedBatteryLongevity = {} }) {
  const theme = useTheme()
  const classes = useStyles({ theme })
  const { lastEstimation, lastEstimationAt, estimatedLongevity } =
    estimatedBatteryLongevity || {}

  let formattedDate
  try {
    formattedDate = dayjs(lastEstimationAt).format('L')
  } catch (e) {
    formattedDate = 'N/A'
  }

  return (
    <div className={classes.container}>
      {lastEstimation && (
        <div className={classes.row}>
          <span className={classes.label}>Most Recent Longevity</span>
          <span className={classes.value}>
            {lastEstimation}
            <span className={classes.valueSecondary}> on {formattedDate}</span>
          </span>
        </div>
      )}
      <div className={classes.row}>
        <span className={classes.label}>Estimated Current Longevity</span>
        <span className={classes.value}>{estimatedLongevity || 'N/A'}</span>
      </div>
    </div>
  )
}

EstimatedLongevity.propTypes = {
  estimatedBatteryLongevity: PropTypes.shape({
    lastEstimation: PropTypes.string,
    lastEstimationAt: PropTypes.string,
    estimatedLongevity: PropTypes.string,
  }),
}
